import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';

export const notificationInfoUrl = '/api/dosi-platform/v1/notifications/user/badge';
export type NotificationInfo = {
  hasUnreadNotification: boolean;
};
export const getNotificationInfo = async () => {
  const { data } = await axios.get<NotificationInfo>(notificationInfoUrl);
  return data;
};
export const useNotificationInfo = (options?: UseQueryOptions<NotificationInfo>) =>
  useQuery<NotificationInfo>({
    ...options,
    queryKey: ['notification', 'info'],
    queryFn: getNotificationInfo,
    initialData: {
      hasUnreadNotification: false,
    },
  });
